module.exports = __webpack_public_path__ + "static/img/no-data.57bbfb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/no-data.png
// module id = WVm3
// module chunks = 1